import * as React from "react";
import { cn } from "../lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
	({ className, type, ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					"flex h-11 w-full rounded-lg border border-default bg-transparent px-4 py-2.5 text-sm shadow-theme-xs transition-colors",
					"placeholder:text-tertiary",
					"focus:border-brand-300 focus:ring-3 focus:ring-brand-500/20 focus:outline-hidden",
					"disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-gray-100 disabled:text-gray-500 disabled:opacity-40",
					"aria-invalid:border-error-500 aria-invalid:focus:border-error-300 aria-invalid:focus:ring-error-500/20",
					"dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30",
					"dark:focus:border-brand-800",
					"dark:disabled:border-gray-700 dark:disabled:bg-gray-800 dark:disabled:text-gray-400",
					"dark:aria-invalid:border-error-500 dark:aria-invalid:text-error-400 dark:aria-invalid:focus:border-error-800",
					className,
				)}
				ref={ref}
				{...props}
			/>
		);
	},
);
Input.displayName = "Input";

export { Input };
